// src/redux/actions/supportAction.js

import { createSupportTicket_api } from "../../../api/support_api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const createSupportTicketAction = createAsyncThunk(
  "support/createTicket",
  async (payload, { rejectWithValue }) => {
    try {
      const safePayload = {
        email: payload?.email?.trim(),
        ticketDescription: payload?.ticketDescription?.trim(),
      };

      const data = await createSupportTicket_api(safePayload);
      return data;
    } catch (err) {
      return rejectWithValue({
        status: err.status,
        message: err.message,
      });
    }
  }
);
